import React, { Component } from "react";
import Registry from "../../../Utils/Registry";
import { NotificationManager } from 'react-notifications';

import TYItem from "../../TYItem";
import ConfirmationModal from "../../ConfirmationModal";


class EnterprisePaymentsItem extends Component{
    constructor(props){
        super(props);

        this.removeItem = this.removeItem.bind(this);
        this.toggleConfirm = this.toggleConfirm.bind(this);

        this.api = Registry.registered("api");

        this.state = {
            loadingDeletion: false,
            confirmationOpen: false
        };
    }

    removeItem(){
        this.setState({loadingDeletion: true, confirmationOpen: false});
        this.api.del("/business/paymentMethods", {card_id: this.props.card ? this.props.card.id : this.props.sepa.id})
            .then(() => {
                this.props.onCardRemove(this);
            })
            .catch(error => {
                this.setState({loadingDeletion: false});
                NotificationManager.error("Impossible de supprimer ce moyen de paiement");
            });
    }

    toggleConfirm(){
        this.setState({confirmationOpen: !this.state.confirmationOpen});
    }

    render(){
        let card_lbl = "**** " + (this.props.card ? this.props.card.last4 : (this.props.sepa.sepa_debit ? this.props.sepa.sepa_debit.last4 : this.props.sepa.last4));
        if(this.props.card && this.props.card.metadata.name)
            card_lbl = this.props.card.metadata.name + " - " + card_lbl;
        else if(this.props.sepa && this.props.sepa.metadata.name)
            card_lbl = this.props.sepa.metadata.name + " - " + card_lbl;

        return (
            <div className="ty-list-item">
                <TYItem
                    icon={"icon icon-" + (this.props.card ? "credit-card" : "bank")}
                    action={{
                        icon: "icon icon-close",
                        backgroundColorHover: "red",
                        colorHover: "white",
                        onclick: this.toggleConfirm
                    }}
                >
                    { card_lbl }
                </TYItem>

                <ConfirmationModal
                    isOpen={this.state.confirmationOpen}
                    toggle={this.toggleConfirm}
                    validate={this.removeItem}
                    refuse={this.toggleConfirm}
                    title="Supprimer le moyen de paiement"
                    content={
                        <div>
                            Etes-vous s&ucirc;r de vouloir supprimer ce moyen de paiement :<br />
                            <span className="bold">{ card_lbl }</span> ?
                        </div>
                    }
                />
            </div>
        );
    }
}


EnterprisePaymentsItem.defaultProps = {
    onCardRemove: card => {},
    card: null,
    sepa: null
};

export default EnterprisePaymentsItem;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Payments/PaymentItem.js